import React from 'react';
import styles from './Service.module.scss';
import {$t} from "../../../helpers/translator";
import ErrorsTable from "../../../components/ErrorsTable/ErrorsTable";
import ErrorsGraph from "../../../components/ErrorsGraph/ErrorsGraph";
import ServiceCallsTable from "../../../components/ServiceCallsTable/ServiceCallsTable";


class ChainService extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className={styles.container}>
                <div className={styles['flex-row']}>
                    <div className={styles['box']}>
                        <ServiceCallsTable userType={3} header={$t('global.service.ServiceCalls')}/>
                    </div>
                </div>

                <div className={styles['flex-row']}>
                    <div className={styles['box']}>
                        <ErrorsTable userType={3} header={$t('global.service.chainPlatformErrors')}/>
                    </div>
                </div>

                <div className={styles['flex-row']}>
                    <div className={styles['box']}>
                        <ErrorsGraph userType={3} header={$t('global.service.chainPlatformErrorsGraph')}/>
                    </div>
                </div>
            </div>
        );
    }
}

export default ChainService;
